export const maskCardNumberToShow = (cardNumber: string): {
    first4Numbers: string,
    last4Numbers: string
} => {
    let first4Numbers = cardNumber.slice(0, 4)
    let last4Numbers = "" 
    
    if(cardNumber.length >= 19){
        last4Numbers = (cardNumber.slice(cardNumber.length - 4, cardNumber.length));
    }

    return {
        first4Numbers: first4Numbers,
        last4Numbers: last4Numbers
    }
}